import React, { Fragment } from 'react';
import {Text, View, Image, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
   
    // agentlogo: {
    //     width: 74,
    //     height: 66,
    //     marginRight: 0,
    //     marginLeft: 400,
    // },
    logo: {
      width: 70,
      height: 40,
       marginBottom: -70,
  },
  agentname: {
     marginBottom: -90,
},
  });


  const AgentImage = () =>{
   
    return(
       <Fragment>
           <View>
           <Image style={styles.logo}  src="images/logo/seyLogo.png" />
           </View>
    </Fragment>
      );
 
   } 
   export default AgentImage